import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=0c63b00e&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=0c63b00e&prod&lang=css"
import style1 from "./Article.vue?vue&type=style&index=1&id=0c63b00e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63b00e",
  null
  
)

export default component.exports